// ======================================================================
// File Name       : SuperuserServiceRoleTopContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Col, Form, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getSuperuserServiceRoleList } from '../../actions/SuperuserServiceRoleAction';
import Header from '../../components/Header';
import CustomLink from '../../components/button/CustomLink';
import { USER_AUTHORITY_ROLE } from '../../constants/AuthorityConstant';
import * as FUNCTION from '../../constants/FunctionConstants';
import * as ICON from '../../constants/IconConstants';
import * as Path from '../../constants/PathConstants';
import { RETURN_MAX_NUM_1000, SELECT_TARGET_DATA, WRITE } from '../../constants/index';
import { canAccessRoute } from '../../utils/AuthedUtils';
import { SYSTEM_CREATE_FLAG } from '../../constants/CommonConstants';

class SuperuserServiceRoleTopContainer extends React.Component {
  /**
     * Constructor function of component
     * @param {*} props
     */
  constructor(props) {
    super(props);
    this.state = {
      authorityInfo: {
        roleList: [],
      },
      startPosition: 0,
      returnMaxNum: RETURN_MAX_NUM_1000,
    };
    this.onSearchData = this.onSearchData.bind(this);
    this.getSuperuserServiceRoleList = this.getSuperuserServiceRoleList.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
  }

  /**
     * Life cycle function of component
     */
  componentDidMount() {
    this.onSearchData();
  }

  static getDerivedStateFromProps(nextProps, state) {
    const { superuserServiceRole: { authorityInfo } } = nextProps;
    if (state.authorityInfo !== authorityInfo) {
      return {
        ...state,
        authorityInfo,
      };
    }
    return state;
  }

  onSearchData() {
    this.setState(
      {
        startPosition: 0,
        returnMaxNum: RETURN_MAX_NUM_1000,
      },
      () => this.getSuperuserServiceRoleList(SELECT_TARGET_DATA.DATA),
    );
  }

  /**
     * Get authority list
     *
     * @param {integer} selectTargetData
     */
  getSuperuserServiceRoleList(selectTargetData) {
    const param = {
      startPosition: this.state.startPosition,
      returnMaxNum: this.state.returnMaxNum,
    };
    this.props.dispatch(getSuperuserServiceRoleList(param));
  }

  /**
     * Pagination
     * @param {*} page
     */
  getStartEndData(startPosition) {
    this.setState(
      {
        startPosition,
      },
      () => {
        this.getSuperuserServiceRoleList();
      },
    );
  }

  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }

  /**
     * Render function of component
     */
  render() {
    const authorityList = this.state.authorityInfo.roleList.map(
      (authority, index) => {
        let btnName = '詳細';
        let className = 'link-detail';
        const { superuserServiceRoleSecernId, superuserServiceRoleName, systemCreateFlag } = authority;
        if (
          systemCreateFlag === SYSTEM_CREATE_FLAG.USER // Step 11.0.0
        ) {
          btnName = '詳細・編集';
          className = 'link-detail-edit';
        }
        const link = `/${Path.SUPERUSER_SERVICE_ROLE}/${superuserServiceRoleSecernId}`;
        return (
          <tr key={superuserServiceRoleSecernId} onMouseEnter={() => this.handleMouseEnter(index)} onMouseLeave={() => this.handleMouseLeave()}>
            <td>
              {superuserServiceRoleName}
            </td>
            <td className="text-center">
              <CustomLink
                className={`margin-right-7 ${className}`}
                to={link}
                text={btnName}
              />
            </td>
          </tr>
        );
      },
    );
    const canAccessRegister = canAccessRoute(FUNCTION.SUPERUSER_SERVICE_ROLE_REGISTER);
    return (
      <div>
        <Col className="padding-left-right-clear display-flex justify-content-end margin-bottom-10">
          {canAccessRegister && (
            <CustomLink
              className="margin-right-7 btn-register"
              to={Path.SUPERUSER_SERVICE_ROLE_REGISTER}
              text="サービスロール追加"
              icon={ICON.REGIST_NEW_ROLE}
            />
          )}
        </Col>
        <Col className="padding-left-right-clear">
          <Form className='form-horizontal'>
            <Table striped hover>
              <thead>
                <tr>
                  <th>ロール名</th>
                  <th width="150">
                    操作
                  </th>
                </tr>
              </thead>
              <tbody>
                {authorityList}
              </tbody>
            </Table>
          </Form>
        </Col>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  ...{ superuserServiceRole: state.superuserServiceRole, enterpriseManagementFunctionAuthorityInfo: state.authed.authedUser.enterpriseManagementFunctionAuthorityInfo },
});

export default connect(mapStateToProps)(SuperuserServiceRoleTopContainer);
